import ServiceFactory from "../service-factory";
import ShareSpaceRecord from "models/view-models/share-spaces/share-space-record";
import ServiceHookFactory from "../service-hook-factory";

export interface ShareSpaceResourcePathParams {
    id?: number;
}

export interface SendShareSpaceServiceParams {
    id: number;
    message: string;
    magicLinkUrlTemplate: string;
}

const baseEndpoint = "sharespaces";
const resourceEndpoint = `${baseEndpoint}/:id`;
const sendPatchEndPoint = `${resourceEndpoint}/send`;
const resourceType = ShareSpaceRecord;

const ShareSpaceService = {
    create: ServiceFactory.create<ShareSpaceRecord>(resourceType, baseEndpoint),
    update: ServiceFactory.update(resourceType, resourceEndpoint),
    usePatchSend: ServiceHookFactory.usePatch<
        ShareSpaceRecord,
        ShareSpaceResourcePathParams,
        SendShareSpaceServiceParams
    >(ShareSpaceRecord, sendPatchEndPoint),
    get: ServiceFactory.get<ShareSpaceRecord, ShareSpaceResourcePathParams>(
        resourceType,
        resourceEndpoint
    ),
    useGet: ServiceHookFactory.useGet<
        ShareSpaceRecord,
        ShareSpaceResourcePathParams
    >(resourceType, resourceEndpoint),
};

export default ShareSpaceService;
